<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      userBadges: []
    }
  },
  mounted() {
    this.getuserBadges();
  },
  methods: {
    getuserBadges() {
      Fandom.ajax({
        method: "GET",
        url: "/api/v5/get_user_badges",
        data: {},
        success: (data) => {
          this.userBadges = data.badges;
        },
      });
    },
  },
  computed: {}
}
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="container py-4" stripe-user-badges>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="row">
          <div class="col-12">
            <h2>{{content.title}}</h2>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-4 col-md-auto pb-4" v-for="badge in userBadges">
            <img :src="badge" class="badge-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[stripe-user-badges] {
  img.badge-image {
    max-width: 70px;
    @include media-breakpoint-down(sm) {
      max-width: 100%;
    }
  }
}
</style>